import { api } from '../api'
import { Campaign } from 'models/Campaign'

export const campaignsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getLegacyCampaign: builder.query<Campaign, string>({
      query: (campaignId: string) => `/campaigns/${campaignId}`,
    }),
    getAnalyticsSettings: builder.query<Campaign, string>({
      query: (campaignId: string) => `/campaigns/${campaignId}/analytics-service-settings`,
    }),
  }),
})

export const {
  useGetLegacyCampaignQuery,
  useGetAnalyticsSettingsQuery,
  endpoints: { getLegacyCampaign, getAnalyticsSettings },
} = campaignsApi
